{
  "name": "m3-bus",
  "seed": 1,
  "track": "stadium",
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "vehicle": "bus", "spawn": { "x": 680, "y": 190, "angle": 0 }, "ai": null }],
  "inputs": [],
  "captures": []
}
